import React from 'react';
import { FaCheck } from "react-icons/fa";

interface ToggleSwitchProps {
  label: string;
  isChecked: boolean;
  onToggle: () => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, isChecked, onToggle }) => (
  <div className="toggleSwitch">
    <label>{label}</label>
    <button onClick={onToggle} className={isChecked ? 'checked' : ''}>
      <span className="slider">
        {isChecked && <span className="checkmark"><FaCheck /></span>}
      </span>
    </button>
  </div>
);

export default ToggleSwitch;
